import { has, toLower } from 'lodash';

const allMonthsObj = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};

const allMonthsEnAr = {
  Jan: 'يناير',
  Feb: 'فبراير',
  Mar: 'مارس',
  Apr: 'أبريل',
  May: 'مايو',
  Jun: 'يونيو',
  Jul: 'يوليو',
  Aug: 'أغسطس',
  Sep: 'سبتمبر',
  Oct: 'أكتوبر',
  Nov: 'نوفمبر',
  Dec: 'ديسمبر',
};

const allMonthsEnArLong = {
  January: 'يناير',
  February: 'فبراير',
  March: 'مارس',
  April: 'أبريل',
  May: 'مايو',
  June: 'يونيو',
  July: 'يوليو',
  August: 'أغسطس',
  September: 'سبتمبر',
  October: 'أكتوبر',
  November: 'نوفمبر',
  December: 'ديسمبر',
};
/*
January يناير
February  فبراير
March مارس
April أبريل
May مايو
June  يونيو
July  يوليو
August  أغسطس
September سبتمبر
October أكتوبر
November  نوفمبر
December  ديسمبر
*/

const checkYearEquality = (start, end) => {
  const startArr = start.split(' ');
  const endArr = end.split(' ');

  if (startArr[2] === endArr[2]) {
    return true;
  }
  return false;
};

const checkMonthEquality = (start, end) => {
  const startArr = start.split(' ');
  const endArr = end.split(' ');

  if (startArr[1] === endArr[1]) {
    return true;
  }
  return false;
};

export const dateToStringNoYear = (date) => {
  const dateSlicer = date.slice(0, 10);
  const dateArr = dateSlicer.split('-');
  const month = allMonthsObj[+dateArr[1]];
  const day = +dateArr[2];
  return `${day} ${month}`;
};

export const dateToString = (date) => {
  const dateSlicer = date.slice(0, 10);
  const dateArr = dateSlicer.split('-');
  const year = dateArr[0];
  const month = allMonthsObj[+dateArr[1]];
  const day = +dateArr[2];
  return `${day} ${month} ${year}`;
};

export const isCurrDate = (currMonth, currYear, startDate, endDate) => {
  const currDate = +`${currYear}${currMonth < 10 ? `0${currMonth}` : currMonth}`;
  const start = +startDate.slice(0, 7).replace(/-/g, '');
  const end = +endDate.slice(0, 7).replace(/-/g, '');
  return currDate >= start && currDate <= end;
};

export const checkDayEquality = (start, end) => start === end;

export const startEndDateToString = (start, end) => {
  const endDate = dateToString(end);
  const startDate = dateToString(start);

  if (checkYearEquality(startDate, endDate)) {
    if (checkMonthEquality(startDate, endDate)) {
      if (checkDayEquality(startDate, endDate)) {
        return endDate;
      }
      return `${+startDate.split(' ')[0]} - ${endDate}`;
    }
    return `${+startDate.split(' ')[0]} ${startDate.split(' ')[1]} - ${endDate}`;
  }
  return `${startDate} - ${endDate}`;
};

export const dateToNum = (date) => {
  const dateSlicer = date.slice(0, 10);
  const dateArr = dateSlicer.split('-');
  const year = dateArr[0];
  const month = dateArr[1];
  const day = dateArr[2];
  return +`${year}${month}${day}`;
};

export const convertMonthToAr = (date) => {
  const dateArr = date.split(' ');
  const newDate = dateArr.map((item, index) => {
    if (has(allMonthsEnAr, item)) {
      return allMonthsEnAr[item];
    }
    return item;
  });
  return newDate.join(' ');
};
